// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".max-width[data-v-3ebde37f]{max-width:50%}.gap[data-v-3ebde37f]{gap:1rem}@media screen and (max-width:768px){.mobile-flex-direction-column[data-v-3ebde37f]{flex-direction:column}.mobile-no-gap[data-v-3ebde37f]{gap:0}.max-width[data-v-3ebde37f]{max-width:100%}.overflow-wrap[data-v-3ebde37f]{overflow-wrap:break-word}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
